import { render, staticRenderFns } from "./MagazzinoArticoliDistinaBaseComponent.vue?vue&type=template&id=7913479f"
import script from "./MagazzinoArticoliDistinaBaseComponent.vue?vue&type=script&lang=js"
export * from "./MagazzinoArticoliDistinaBaseComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports